<template>
    <div class="mgx_key_group_container">
        <div class="device_switch">
            <template v-if="isThereGroup == false">
                <div class="item" @click="selectAllKeys" :class="{ 'selected': isSelectedAllKeys }"
                    @mouseenter="handleAllMouseEnter()" @mouseleave="handleAllMouseLeave()">
                    <input class="selector" type="checkbox" v-model="isSelectedAllKeys">
                    </input>
                    {{ $t('all_keys_selected') }}
                </div>
            </template>

            <template v-else >
                <template v-for="([key, value]) in sortedKeyGroups">
                <div class="item" @click="selectKeyGroup(key)" @mouseenter="handleMouseEnter(key)"
                    @mouseleave="handleMouseLeave(key)"
                    v-if="((magnetSetKeyGroup.state.keysGroup.get(key) || []).length > 0)"
                    :class="{ 'selected': key == magnetSetKeyGroup.state.keysGroupType }">                    
                    <input class="selector" type="checkbox" :checked="key == magnetSetKeyGroup.state.keysGroupType">
                    </input>
                    {{ $t(value?.groupNameTranslationKey || '') }}
                    <span
                        v-if="magnetSetKeyGroup.state.defaultKeysGroup == key && !specialCheckCurrent(speciaBehiver.Device_UnknownAxis)">-{{
                            $t('magnet_original') }}</span>
                </div>
                </template>
            </template>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { KK } from '@/define/define';
import { KeyGroupInfoMap } from '@/define/key_group';
import { speciaBehiver, specialCheckCurrent } from '@/define/limit';
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector';
import { magnetSetKeyGroup } from '@/service/driver/magnet_key_group';
import { magnetSet } from '@/service/driver/magnet_set';
import { KeyGroup } from '@libs/types/enum';

import { computed, onMounted, ref, watch } from 'vue';
const isSelectedAllKeys = ref<boolean>(false)
onMounted(() => {
    watch(magnetSet.selectedKeys, (values: KK[]) => {
        const isShow = values.length === getCurrentDeviceMagnetKKs.value.length ? true : false
        isSelectedAllKeys.value = isShow
    })
})

const sortedKeyGroups = computed(() => {
    const map = KeyGroupInfoMap();
    const defaultGroup = magnetSetKeyGroup.state.defaultKeysGroup;

    return Array.from(map.entries()).sort((a, b) => {
        if (a[0] === defaultGroup) return -1;
        if (b[0] === defaultGroup) return 1;
        return 0;
    });
})

const computedSelectedText = computed(() => {
    const info = KeyGroupInfoMap().get(magnetSetKeyGroup.state.keysGroupType)
    if (info) {
        return `${info.groupNameTranslationKey}`
    } else {
        return ""
    }
})

const selectAllKeys = () => {
    if (isSelectedAllKeys.value) {
        magnetSet.selectedKeys.value = [];
    } else {
        magnetSet.selectedKeys.value = getCurrentDeviceMagnetKKs.value.map(v => parseInt(v.toString(), 10));
    }
    isSelectedAllKeys.value = !isSelectedAllKeys.value
    magnetSetKeyGroup.state.hoverKeys.length = 0
}

const selectKeyGroup = (item: KeyGroup) => {
    if (magnetSetKeyGroup.state.keysGroupType == item) {
        magnetSetKeyGroup.state.keysGroupType = KeyGroup.none;
    } else {
        magnetSetKeyGroup.state.keysGroupType = item
    }
    const kks = magnetSetKeyGroup.state.keysGroup.get(magnetSetKeyGroup.state.keysGroupType) || []
    const ks = JSON.parse(JSON.stringify([...kks]))
    magnetSet.selectedKeys.value = ks
    magnetSetKeyGroup.state.hoverKeys.length = 0;
}

// 检查magnetSetKeyGroup.keysGroup.value中是否存在除了KeyGroup.default以外的分组
// 是否存在分组
const isThereGroup = computed(() => {
    for (const [key, values] of magnetSetKeyGroup.state.keysGroup) {
        if (values.length > 0 && key != magnetSetKeyGroup.state.defaultKeysGroup) {
            return true;
        }
    }
    return false;
})
const handleAllMouseEnter = () => {
    magnetSetKeyGroup.state.hoverKeys = getCurrentDeviceMagnetKKs.value.map(v => parseInt(v.toString(), 10))
}
const handleAllMouseLeave = () => {
    magnetSetKeyGroup.state.hoverKeys.length = 0
}
const handleMouseEnter = (item: KeyGroup) => {
    const kks = magnetSetKeyGroup.state.keysGroup.get(item) || []
    const ks = JSON.parse(JSON.stringify([...kks]))
    magnetSetKeyGroup.state.hoverKeys = ks
}
const handleMouseLeave = (_item: KeyGroup) => {
    magnetSetKeyGroup.state.hoverKeys.length = 0
}

</script>

<style lang="less" scoped>
.mgx_key_group_container {
    margin-bottom: 0;
    width: max-content;
    max-width: 100%;
}

.device_switch {
    display: flex;
    align-items: center;
    color: var(--color-dark);
    flex-wrap: wrap;
    gap: 12px;

    .item {
        cursor: pointer;
        font-size: 13px;
        background: rgba(255, 255, 255, 0.45);
        backdrop-filter: blur(16px);
        padding: 8px 16px;
        color: rgba(34, 34, 34, 0.66);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-m);
        text-wrap: nowrap;
        transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        border: 1px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        font-weight: 800;

        &.selected {
            background: rgba(255, 255, 255, 0.94);
            color: var(--brand-color-pure);
            border-color: rgba(255, 255, 255, 0.9);
            font-weight: 900;
            box-shadow: 0 8px 20px rgba(var(--color-brand-1-rgb), 0.12);
            transform: translateY(-2px);
        }

        &:hover:not(.selected) {
            background: rgba(255, 255, 255, 0.62);
            color: var(--color-dark);
            border-color: rgba(255, 255, 255, 0.42);
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
        }

        .selector {
            display: none;
        }
    }
}
</style>
